import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFileDownload = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M2.25.5A.25.25 0 0 1 2.5.25h7a.25.25 0 0 1 .177.073l4 4a.25.25 0 0 1 .073.177v11a.25.25 0 0 1-.25.25h-11a.25.25 0 0 1-.25-.25zm.5.25v14.5h10.5V4.604L9.396.75z",
		clipRule: "evenodd"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M9.5.25a.25.25 0 0 1 .25.25v3.75h3.75a.25.25 0 1 1 0 .5h-4a.25.25 0 0 1-.25-.25v-4A.25.25 0 0 1 9.5.25M8 6a.25.25 0 0 1 .25.25v4.817l1.459-1.728a.25.25 0 0 1 .382.322l-1.9 2.25a.25.25 0 0 1-.382 0l-1.9-2.25a.25.25 0 0 1 .382-.322l1.459 1.727V6.25A.25.25 0 0 1 8 6",
		clipRule: "evenodd"
	})]
});
export default SvgFileDownload;
